package ru.arty_bikini.crm_frontend.ui.input.table

data class TablePanelEntity<T>(
    val entity: T,
    val new: Boolean = false,
    val updated: Boolean = false,
    val removed: Boolean = false
)